export default __webpack_public_path__ + "static/media/icn_map_pin_attended.1c9c88f2.svg";